<template>
	<div>
		<div class="filter-inline-panel cle" v-if="user_id==0">
			<el-form :inline="true" size="mini" :model="pages" class="filter-panel">
				<el-form-item :label="$t('parent_index.seller')" prop="seller_id">
					<el-select v-model="pages.seller_id" class="w100" :placeholder="$t('index.select')">
						<el-option v-for="(item,index) in sellerList" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('course_index.date')" prop="date" data-name="日期">
					<el-date-picker v-model="pages.date" clearable value-format="timestamp" type="daterange" :range-separator="$t('course_index.range')" :start-placeholder="$t('course_index.startdate')" :end-placeholder="$t('course_index.enddate')"></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" size="mini" @click="handleCurrentChange(1)">{{$t('index.search')}}</el-button>
					<el-button type="primary" size="mini" @click="reset(1)">{{$t('index.reset')}}</el-button>
				</el-form-item>
			</el-form>
		</div>
		<el-table :data="list" border size="mini">
			<el-table-column prop="order_id" align="center" :label="$t('order.no')" data-name="订单id" width="140"></el-table-column>
			<el-table-column prop="course_name" align="center" :label="$t('course_index.theme')" data-name="主题" min-width="200">
				<template slot-scope="scope">
					<a target="_blank" class="clo3" :href="href_root(scope.row)">{{scope.row.course_name}}</a>
				</template>
			</el-table-column>
			<el-table-column prop="create_time" align="center" :label="$t('order.create_time')" data-name="购买时间" width="140">
				<template slot-scope="scope">{{getTime_us(scope.row.create_time,'mmddyyyy')}}  {{getTime_us(scope.row.create_time,'ampm')}}</template>
			</el-table-column>
			<el-table-column prop="surplus" align="center" :label="$t('course_index.max_people')" data-name="班级规模" width="70">
				<template slot-scope="{row}">{{row.student_num}}/{{row.max_people}}</template>
			</el-table-column>
			<el-table-column prop="tel" align="center" :label="$t('parent_index.user_name')" width="100"></el-table-column>
			<el-table-column prop="user_name" align="center" :label="$t('parent_index.name')" data-name="家长" min-width="90"></el-table-column>
			<el-table-column prop="child_name" align="center" :label="$t('order.children')" data-name="学生" min-width="90"></el-table-column>
			<el-table-column prop="age" align="center" :label="$t('course_index.age')" data-name="年龄" width="50">
				<template slot-scope="{row}">{{row.age>50?'成人':row.age}}</template>
			</el-table-column>
			<el-table-column prop="teacher_name" align="center" :label="$t('course_index.teacher')" data-name="老师"></el-table-column>
			<el-table-column prop="seller_name" align="center" :label="$t('parent_index.seller')" data-name="销售"></el-table-column>
			<el-table-column prop="start_date" align="center" :label="$t('course_index.date')" data-name="日期" width="180">
				<template slot-scope="scope">{{getTime_us(scope.row.start_date,'mmddyyyy')}} ~ {{getTime_us(scope.row.end_date,'mmddyyyy')}}</template>
			</el-table-column>
			<el-table-column prop="start_time" align="center" :label="$t('course_index.time')" data-name="时间" width="100">
				<template slot-scope="scope">{{getTime_us(scope.row.start_time,'hh:ii')}}-{{getTime_us(scope.row.end_time,'hh:ii')}}</template>
			</el-table-column>
			<el-table-column prop="price" align="center" :label="$t('course_index.price')" data-name="学费" width="100"></el-table-column>
			<el-table-column prop="coupon_price" align="center" :label="$t('order.discount')"></el-table-column>
			<el-table-column prop="score" align="center" :label="$t('order.score')"></el-table-column>
			<el-table-column prop="pay_price" align="center" :label="$t('order.total')"></el-table-column>
			<el-table-column prop="classes_delete_flag" align="center" :label="$t('order.state')">
				<template slot-scope="{row}">
					<div v-if="row.classes_delete_flag>0">{{classes_delete_flag[row.classes_delete_flag]}}</div>
					<div v-else>{{$t('order.normal')}}</div>
				<!-- {{row.classes_delete_flag?$t('order.refund'):$t('order.normal')}} -->
				</template>
			</el-table-column>
			<el-table-column prop="remarks" align="center" :label="$t('student_list.remarks')"></el-table-column>
			<el-table-column :label="$t('index.operation')" align="center" fixed="right" width="100">
				<template slot-scope="scope">
					<el-button size="mini" type="danger" @click="del(scope.row)">{{$t('index.del')}}</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="page-pagination">
			<el-pagination align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pager-count="5"></el-pagination>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			API_URL:process.env.API_URL,
			pages: {
				page: 1,
				count: 0,
				perpage: 20,
				seller_id:'',
				date:null,
			},
			list:[],
			sellerList:[],
			type:{'camps':'camps'},
			classes_delete_flag:[this.$t('order.normal'),this.$t('order.refund_fee'),this.$t('order.suspend')],
		}
	},
	props:{
		user_id: {
			type: [Number,String],
			default:0
		},
		child_id: {
			type: [Number,String],
			default:0
		},
		seller_id: {
			type: Number,
			default:0
		},
	},
	// 初始事件
	mounted: function () {
		this.config();
		this.init();
	},
	// 事件
	methods: {
		config() {
			var this_ = this;
			var url = "sellerListNoPage";
			this_.$post(url, {seller_type:'seller'}).then((res) => {
				this_.sellerList = res;
			})
		},
		init(){
			var this_ = this;
			var url = "userCourseList";
			var datas = {
				user_id:this_.user_id||'',
				page: this_.pages.page,
				num: this_.pages.perpage,
				seller_id: this_.pages.seller_id,
				child_id: this_.child_id||'',
			};
			if(this_.pages.date&&this_.pages.date.length>0){
				datas['start_time']=this_.pages.date[0]/1000;
				var time=(24*60*60-1)*1000;
				datas['end_time']=(this_.pages.date[1]+time)/1000;
			}
			this_.$post(url, datas).then((res) => {
				this_.list = res.list;
				this_.pages.count = res.sum;
			})
		},
		reset(){
			this.pages.seller_id='';
			this.handleCurrentChange(1);
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		},
		// 删除
		del(data) {
			var this_ = this;
			this.$confirm(this.$t('index.confirm_delete'), this.$t('index.tips')).then(() => {
				this.$post("user/unshowClasses", {classes_id:data.classes_id}).then((res) => {
					this.$message.success(this.$t('index.delete_success'));
					this.init();
				})
			}).catch(() => {});
		},
		href_root(data){
			var type={
				'course':'#/course_info?id=',
				'camp':'#/course_camps_info?id=',
				'activity':'#/course_activity_info?id=',
				'private':'#/course_private_info?id='
			}
			return this.API_URL+type[data.type]+data.id;
		},
		// 优惠金额
		amount_jisuan(data){
			var coupon_price=data.coupon_price?parseFloat(data.coupon_price):0;
			var score=data.score?parseFloat(data.score):0;
			// var use_score=data.use_score?parseFloat(data.use_score):0;
			var zhi= coupon_price+score;
			return zhi.toFixed(2);
		},
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.font_input{
	line-height: 1.4;
}
.page-pagination{
	padding: 20px 10px 0;
}
.roll_history{
	padding: 20px 0;
}
.roll_history .p1{
	font-size: 20px;
	color: #000000;
	font-weight: bold;
	margin-bottom: 10px;
}
.roll_history .p2{
	margin-bottom: 40px;
	font-size: 20px;
	color: #000000;
}
.roll_history .p2 span{
	margin-right: 30px;
	margin-bottom: 20px;
}
.img_img{
	float: left;
	margin-right: 10px;
	width: 232px;
	height: 230px;
	margin-bottom: 10px;
}
.img_img:nth-child(4n){
	margin-right: 0;
}
.img_img .video{
	width: 100%;
	height: 100%;
	object-fit: contain;
}
.clo3{
	color: #ff0000;
}
</style>



// WEBPACK FOOTER //
// src/components/sellerOrderList.vue